import colors from '../theme/colors';

const styleOverrides = {
  root: {
    height: '8px',
    borderRadius: '8px',
    backgroundColor: colors.solidGray[200],
  },
};

export default styleOverrides;
